// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"s6eki","headerWrapper":"_1yE3Q","contentWrapper":"_3drdu","header":"_2IWyp","closeIcon":"H5bna","content":"_1JQSH"};